
class AppOverlayController {
    constructor(AppOverlay) {
        this._appOverlaySvc = AppOverlay;
    }

    $onInit() {
        this._appOverlaySvc.showOverlay = false;
        this._appOverlaySvc.overlayMessage = "Loading";
        this._appOverlaySvc.overlayType = "primary";
    }

    get overlayVisible() {
        return this._appOverlaySvc.showOverlay;
    }

    get overlayText() {
        return this._appOverlaySvc.overlayMessage;
    }

    get overlayType() {
        return this._appOverlaySvc.overlayType;
    }

    closeOverlay() {
        this._appOverlaySvc.showOverlay = false;
    }
}

AppOverlayController.$inject = [
    "AppOverlay"
];
AppOverlayController.controllerAs = "appOverlayCtrl";
AppOverlayController.template = require("./AppOverlay.tpl.html");

AppOverlayController.dependencies = [];

export default AppOverlayController;



//////////////////
// WEBPACK FOOTER
// ./src/directives/app-overlay/AppOverlayController.js
// module id = OADj
// module chunks = 1